import { authStorage } from '@/lib/auth';
import type {
  AdminDisputeGroup,
  AdminPendingAuction,
  AdminBan,
} from '@/types/domain';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';

async function adminRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const token = authStorage.getToken();
  const res = await fetch(`${API_BASE}/admin${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers as Record<string, string>),
    },
  });
  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      message = body.message ?? message;
    } catch {}
    throw new Error(message);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export const adminApi = {
  // Споры
  listComplaints(): Promise<AdminDisputeGroup[]> {
    return adminRequest('/complaints?status=open');
  },
  resolveComplaint(id: string, decision: 'ban' | 'dismiss', note: string | null) {
    return adminRequest(`/complaints/${id}/resolve`, {
      method: 'POST',
      body: JSON.stringify({ decision, note }),
    });
  },

  // Модерация лотов
  listPendingAuctions(): Promise<AdminPendingAuction[]> {
    return adminRequest('/auctions/pending');
  },
  moderateAuction(id: string, action: 'approve' | 'reject', note: string | null) {
    return adminRequest(`/auctions/${id}/moderate`, {
      method: 'POST',
      body: JSON.stringify({ action, note }),
    });
  },

  // Баны
  listBans(): Promise<AdminBan[]> {
    return adminRequest('/bans');
  },
  unbanUser(userId: string, note: string | null) {
    return adminRequest(`/users/${userId}/unban`, {
      method: 'POST',
      body: JSON.stringify({ note }),
    });
  },
  banUserByUsername(telegramUsername: string, details: string | null) {
    return adminRequest('/users/ban-by-username', {
      method: 'POST',
      body: JSON.stringify({
        telegram_username: telegramUsername,
        details,
      }),
    });
  },
};